import api, { refreshAccessToken } from './httpService';

export const loginUser = async (email: string, password: string) => {
    try {
        const res = await api.post('/auth/login', { email, password });
        return res.data;
    } catch (error) {
        console.error('Login request failed:', error);
        throw error;
    }
};

export const refreshAuthSession = () => refreshAccessToken();

export const logoutUser = async () => {
    await api.post('/auth/logout', {}, {
        headers: { 'X-CSRF-Protection': '1' },
    });
};

const BOOTSTRAP_ENDPOINTS = ["/auth/me", "/auth/bootstrap", "/me", "/bootstrap"];

export const getAuthBootstrap = async () => {
    let lastError: unknown;

    for (const endpoint of BOOTSTRAP_ENDPOINTS) {
        try {
            const res = await api.get(endpoint);
            return res.data;
        } catch (error) {
            lastError = error;
        }
    }

    throw lastError;
};

export const signupUser = async (data: {
    gymName: string;
    email: string;
    password: string;
    confirmPassword: string;
    address: string;
    mobile: string;
}) => {
    const res = await api.post('/auth/signup', data);
    return res.data;
};
